import styled from "styled-components";

export const FeaturedProductsWrapper = styled.section`
  margin-top: 2rem;
  margin-bottom: 2rem;
`;
